import { render, staticRenderFns } from "./TagsContainer.ts.vue?vue&type=template&id=709a7052"
import script from "./TagsContainer.ts.vue?vue&type=script&lang=ts"
export * from "./TagsContainer.ts.vue?vue&type=script&lang=ts"
import style0 from "./TagsContainer.ts.vue?vue&type=style&index=0&id=709a7052&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports